module.exports = __webpack_public_path__ + "static/media/logo.b0795c30.png";